module.exports = __webpack_public_path__ + "static/thinking-physics-is-gedanken-physics-293afddc9cb66d9f1cb4e0be7a0954d6.jpg";